import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useCookies } from 'react-cookie';
import { filterQuery } from '@culture/common-helpers/url';

import { entityTitlesHash } from '@culture/utils/helpers/entities';
import Button from 'components/Button';

import withAuthorization from 'hocs/withAuthorization';
import { useIsFavorite } from 'hooks/useIsFavorite';

import { PVI_NO_STYLES_CLASSNAME } from 'utils/helpers/inclusion';

const FavoritesButton = ({ entityType, entityId, ...props }) => {
	const [isFavorite, toggleFavorite] = useIsFavorite({ entityType, entityId });
	const [, setCookie] = useCookies(['favorite']);

	const onAuthorizationRequest = useCallback(() => {
		const data = filterQuery({ entityType, entityId, title: props.title });

		setCookie('favorite', data, { path: '/' });
	}, [entityType, entityId]);

	const WrappedToggleButton = withAuthorization({
		text: 'Авторизуйтесь на портале, чтобы добавить страницу в избранное.',
		onButtonClick: onAuthorizationRequest
	})(Button);

	return isFavorite ? (
		<Button
			icon="favorite"
			iconClassName={PVI_NO_STYLES_CLASSNAME}
			tooltip="Убрать из избранного"
			onClick={toggleFavorite}
			theme="circleGrayOutline"
			active
			role="button"
			{...props}
			title=""
		/>
	) : (
		<WrappedToggleButton
			icon="favorite"
			iconClassName={PVI_NO_STYLES_CLASSNAME}
			tooltip="Добавить в избранное"
			onClick={toggleFavorite}
			theme="circleGrayOutline"
			{...props}
			title=""
		/>
	);
};

FavoritesButton.propTypes = {
	entityType: PropTypes.oneOf(Object.keys(entityTitlesHash)).isRequired,
	entityId: PropTypes.number.isRequired,
	title: PropTypes.string.isRequired
};

export default FavoritesButton;
